import { HttpError } from './http.error';

export class AccessDeniedError extends HttpError {
  constructor(message?: string) {
    super(403, message);
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/access-denied.error.ts